import { MsalProvider } from '@azure/msal-react';

import msalInstance from '../msal-instance';

// ----------------------------------------------------------------------

export type AuthProviderProps = React.PropsWithChildren<{}>;

export function AuthProvider({ children }: AuthProviderProps) {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}
